import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SystemcodeApi } from "../api-service/system-code/systemcode-api";
import { GroupMsgData } from "../signalr-service";
import { ClinicDataService } from "../data-service/clinic-data-service";
import { EasyNotificationService } from "../easy-notification.service";
import { PricingApi } from "../api-service/pricing/pricing-api";
import { MainLayoutService } from "src/app/layout/services/main-layout.service";

export interface HistChangedEvent {
  RegId: number;
  HistoryId: number;
  Action: string;
  ActorUserId: number;
  ActorName: string;
  ConnectionId?: string;
  OccurredAtUtc: string;
}

export interface RegisterChangedEvent {
  RegId: number;
}

@Injectable({
  providedIn: 'root'
})
export class ClinicEventHandler {
  onWaitingListNeedRefresh = new EventEmitter();
  onPharmacyListNeedRefresh = new EventEmitter();
  onHistChanged = new EventEmitter<HistChangedEvent>();
  onRegisterChanged = new EventEmitter<RegisterChangedEvent>();
  /**
   *
   */
  constructor(private clinicData: ClinicDataService,
    private notify: EasyNotificationService,
    private mainlayout:MainLayoutService,
    private pricingApi: PricingApi,
  ) {
  }
  /** 執行事件 */
  Invoke(evt: GroupMsgData) {
    if (evt.Type == 'Action') {
      this.doAction(evt);
    } else if (evt.Type == 'Notify') {
      this.doNotify(evt);
    }
  }
  /** 動作事件 */
  private doAction(evt: GroupMsgData) {
    switch (evt.Act) {
      case "UpdateDx":
        this.clinicData.UpdateDx(evt.Arg);
        break;
      case "UpdateRx":
        this.clinicData.UpdateRx(evt.Arg);
        break;
      case "UpdateRs":
        this.clinicData.UpdateRs(evt.Arg);
        break;
      case "UpdateSystemCode":
        this.clinicData.UpdateSystemCode(evt.Arg);
        break;
      case "DeleteSystemCode":
        this.clinicData.DeleteSystemCode(evt.Arg);
        break;
      case "UpdateParameterProfile":
        this.clinicData.updateParam(evt.Arg);
        break;
      case "UpdateStat":
        this.clinicData.UpdateStat(evt.Arg);
        break;
      case "PharmacistChange":
        this.pricingApi.GetEditOptions(true);
        break;
      case "HistChanged":
        if (evt.Arg) {
          this.onHistChanged.emit(evt.Arg as HistChangedEvent);
        }
        break;
      case "RegisterChanged":
        if (evt.Arg) {
          this.onRegisterChanged.emit(evt.Arg as RegisterChangedEvent);
        }
        break;
      case "RefreshWaitList":
        this.onWaitingListNeedRefresh.emit();
        break;
      case "SPSRecieved":
        //this.notify.showInfo('收到新的衛星藥局藥單了')
        this.onPharmacyListNeedRefresh.emit();
        // const msg = new SpeechSynthesisUtterance();
        // msg.text = "丁董丁董";
        // msg.lang = "zh-TW"; // 語言，可用 "en-US"、"ja-JP"...
        // msg.rate = 0.8; // 速度 (0.1 ~ 10)
        // msg.pitch = 2; // 音調 (0 ~ 2)
        // window.speechSynthesis.speak(msg);
        //this.mainlayout.playNotifySound();
        break;
    }
  }
  private doNotify(evt: GroupMsgData) {
    this.notify.showInfo(evt.Arg);
  }
}
